import { Card, Col, Row } from 'antd';
import ContentPageLayout from 'components/Layouts/ContentPageLayout';
import VoteButton from 'components/Vote/VoteButton';
import MonthlyVotesWidget from 'components/Widgets/MonthlyVotesWidget';
import UserWidget from 'components/Widgets/UserWidget/UserWidget';
import React, { useEffect } from 'react';
import { GetVotePageQuery, useGetVotePageQuery, VoteProvider, VoteProviderUpdateDocument, VoteProviderUpdateSubscription } from 'services/api/GraphqlTypes';
import useUser from 'services/hooks/useUser';

const tempImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==";

const dummyVoteProviders: VoteProvider[] = [];
for (let i = 1; i <= 6; i++) {
    dummyVoteProviders.push({
        name: "long name" + i,
        image: tempImage,
        voteUrl: ""
    });
}

const Vote: React.FC = () => {
    const { data, loading, refetch, subscribeToMore } = useGetVotePageQuery();
    const [user] = useUser();
    const isLoggedIn = !!user;

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        return subscribeToMore<VoteProviderUpdateSubscription>({
            document: VoteProviderUpdateDocument,
            updateQuery: (prev, { subscriptionData }) => {
                console.log("Message received", subscriptionData);
                if (!subscriptionData.data) return prev;
                const provider = subscriptionData.data.voteProviderUpdate;
                if (!provider) return prev;
                const index = prev.voteProviders.findIndex(x => x.name === provider.name);
                const newProviders = [...prev.voteProviders];
                if (index < 0) {
                    newProviders.push(provider);
                } else {
                    newProviders.splice(index, 1, provider)
                }

                return Object.assign<{}, GetVotePageQuery, GetVotePageQuery>({}, prev, {
                    voteProviders: newProviders
                });
            }
        });
    }, [isLoggedIn]);

    const voteProviders = data?.voteProviders || dummyVoteProviders;

    useEffect(() => {
        const first = data?.voteProviders.first();
        if (!first) return;
        if (Boolean(user) === Boolean(first.voteUrl)) return;
        refetch()
    }, [user, data, refetch]);

    return (
        <ContentPageLayout
            pageHeader="Vote"
        >
            <Row wrap gutter={[16, 16]}>
                <Col
                    span={24}
                    lg={18}
                >
                    <Row wrap gutter={[16, 16]}>
                        {voteProviders.map(provider => {
                            return (
                                <Col key={provider.name} span={24} sm={12} md={8} lg={6}>
                                    <Card
                                        hoverable={!loading}
                                        loading={loading}
                                        bordered={false}
                                        cover={provider.image &&
                                            <div
                                                style={{
                                                    height: 150,
                                                    backgroundImage: `url(${provider.image})`,
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'contain',
                                                    backgroundPosition: 'center'
                                                }}
                                            />
                                        } // make height 150px
                                    >
                                        {/* <Meta title="RSPS List" /> */}
                                        <VoteButton
                                            href={provider.voteUrl!}
                                            disabledUntil={provider.disabledUntil || undefined}
                                            disabled={!isLoggedIn}
                                            style={{ marginTop: 16 }}
                                        >
                                            {isLoggedIn ? "VOTE" : "Login to vote"}
                                        </VoteButton>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </Col>

                <Col span={24} lg={{ span: 6, order: 2 }}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <UserWidget />
                        </Col>

                        <Col span={24}>
                            <MonthlyVotesWidget />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </ContentPageLayout>
    );
}

export default Vote;